import React from 'react';
import './Phone.scss';
import { replaceSpecialCharacterWith } from '../../../utils/shoppingCart/shopping-cart-utility';

const Phone = ({ phoneNumber, phoneStyleName }) => {
  let linkNumber, displayNumber;
  if (Array.isArray(phoneNumber)) {
    linkNumber = phoneNumber[0];
    displayNumber = `${phoneNumber[0]} (${phoneNumber[1]})`;
  } else {
    linkNumber = phoneNumber;
    displayNumber = phoneNumber;
  }
  return (
    <span className={`text-nowrap exclude ${phoneStyleName}`}>
      <a data-testid="phone" className={`phone hidden-xs exclude`}>
        {displayNumber}
      </a>
      <a
        className={`phone visible-xs-inline exclude`}
        href={'tel:+1' + replaceSpecialCharacterWith(linkNumber, '')}
      >
        {linkNumber}
      </a>
      {Array.isArray(phoneNumber) && (
        <span className={`exclude phone visible-xs-inline`}>
          ({phoneNumber[1]})
        </span>
      )}
    </span>
  );
};

export default Phone;
